<a
  [routerLink]="isSplitting ? null : isDraft ? ['/app', 'meetings', meeting.id, 'setup'] : ['/app', 'meetings', meeting.id]"
  [queryParams]="{ isSearchOpen: null }"
  queryParamsHandling="merge"
  [class.splitting]="isSplitting"
  [matTooltip]="isSplitting ? ('MEETINGS.SPLITTING_IN_PROGRESS' | translate) : ''"
  matTooltipShowDelay="0"
>
  <div class="panel" [class.active]="isActive" [class.compact]="useCompactMode">
    <div class="row main">
      <div class="thumbnail">
        <img
          [ngSrc]="meeting.thumbnailUrl !== null ? meeting.thumbnailUrl : './assets/images/thumbnail-placeholder.png'"
          onerror="this.src = './assets/images/thumbnail-placeholder.png'"
          alt=""
          width="100"
          height="70"
        />
      </div>
      <div class="right-container">
        <div class="details">
          <div class="title">{{ meeting.name }}</div>
          <div class="counterparty-names" [matTooltip]="!useCompactMode ? formattedCounterpartyNames : ''">{{ formattedCounterpartyNames }}</div>
          <div class="footer">
            @if (isDraft) {
              <mat-chip class="small-chip draft-chip">{{ 'MEETINGS.DRAFT_CHIP' | translate }}</mat-chip>
            }
            <span
              [matTooltip]="
                !useCompactMode
                  ? (meeting.date | date: 'd MMM y') +
                    ' · ' +
                    (meeting.date | date: 'HH:mm') +
                    (meeting.duration ? ' · ' + (meeting.duration | duration) + 's' : '')
                  : ''
              "
            >
              {{ meeting.date | date: 'd MMM y' }} · {{ meeting.date | date: 'HH:mm' }}{{ meeting.duration ? ' · ' + (meeting.duration | duration) + 's' : '' }}
            </span>
            @if (meeting.accessLevel === 'COMMENTER') {
              <mat-icon class="access-level-icon" [matTooltip]="'MEETINGS.SHARE_DIALOG.LEVELS.COMMENTER' | translate">comment</mat-icon>
            } @else if (meeting.accessLevel === 'REVIEWER') {
              <mat-icon class="access-level-icon" [matTooltip]="'MEETINGS.SHARE_DIALOG.LEVELS.REVIEWER' | translate">rate_review</mat-icon>
            } @else if (meeting.accessLevel === 'EDITOR') {
              <mat-icon class="access-level-icon" [matTooltip]="'MEETINGS.SHARE_DIALOG.LEVELS.EDITOR' | translate">edit_note</mat-icon>
            }
          </div>
        </div>
        @if (!useCompactMode) {
          <div class="menu-container">
            <div class="top-row">
              @if (!meeting.isPostProcessingComplete) {
                <button mat-icon-button (click)="toggleNotificationSetting($event)">
                  @if (meeting.notifyWhenPostProcessingCompletes) {
                    <mat-icon [matTooltip]="'MEETINGS.NOTIFICATIONS.DONT_NOTIFY_ME' | translate">notifications_active</mat-icon>
                  } @else {
                    <mat-icon [matTooltip]="'MEETINGS.NOTIFICATIONS.NOTIFY_ME' | translate">notifications</mat-icon>
                  }
                </button>
              }
              @if (meeting.meetingSetIndex !== null && meeting.meetingSetSize !== null && meeting.meetingSetSize > 1) {
                <div
                  class="part-badge"
                  [matTooltip]="'MEETINGS.PART_BADGE_TOOLTIP' | translate: { index: meeting.meetingSetIndex + 1, total: meeting.meetingSetSize }"
                >
                  {{ 'MEETINGS.PART_BADGE_TEXT' | translate: { index: meeting.meetingSetIndex + 1, total: meeting.meetingSetSize } }}
                </div>
              }
            </div>
            @if (!isSplitting) {
              <div class="menu">
                <button mat-icon-button (click)="onMenuClick($event)" [matMenuTriggerFor]="menu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item translate="COMMON.DELETE" (click)="delete(meeting)"></button>
                </mat-menu>
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (meeting.isPrevious && meeting.processingStatus) {
      <div class="row processing-progress">
        <div class="processing-progress-header">
          <span class="processing-progress-label">
            @if (isSplitting) {
              {{ 'MEETINGS.PROCESSING_STATUSES.SPLITTING_MEETING' | translate }}
            } @else if (meeting.processingStatus === 'GENERATING_MINUTES' && meeting.minutesGenerationTemplateProgress; as tp) {
              {{ 'MEETINGS.PROCESSING_STATUSES.GENERATING_MINUTES_FOR_AGENDA_ITEM' | translate: { level: tp.level } }}
            } @else {
              {{ 'MEETINGS.PROCESSING_STATUSES.' + meeting.processingStatus | translate }}
            }
          </span>
          @if (meeting.processingProgress !== null) {
            <span class="processing-progress-percentage">{{ meeting.processingProgress }}%</span>
          }
        </div>
        @if (meeting.processingProgress !== null) {
          <app-progress-loader [value]="meeting.processingProgress" loading></app-progress-loader>
        } @else {
          <app-progress-loader indeterminate></app-progress-loader>
        }
      </div>
    }
    @if (meeting.matches !== undefined && meeting.matches.length > 0) {
      <div class="row matches">
        @for (match of meeting.matches; track match.speakerId) {
          <div
            class="match"
            [matTooltip]="match.sentence"
            [class.active]="activeMatch === match.sentenceSearchId"
            [style.left.%]="getMatchLeft(meeting, match.startTimeSeconds)"
          ></div>
        }
      </div>
    }
  </div>
</a>
